<script setup lang="ts">
import type { FunctionalComponent, VNodeProps } from 'vue';
import type { HTMLAttributes } from 'vue';

withDefaults(
  defineProps<{
    leftLabel?: string;
    actionText?: string;
    iconName?:
      | FunctionalComponent<HTMLAttributes & VNodeProps, {}, any, {}>
      | string;
    bg?: string;
    disabled?: boolean;
  }>(),
  {
    leftLabel: '',
    actionText: '',
    iconName: '',
    bg: 'bg-layer-secondary',
    disabled: false,
  },
);
const emits = defineEmits<{ (e: 'action'): void }>();
</script>

<template>
  <div
    class="!rounded-lg flex justify-between items-center px-2 w-full text-xs mb-2 cursor-pointer relative"
    :class="[bg]"
    @click="emits('action')"
  >
    <slot name="left-label">
      <span
        v-if="!!leftLabel"
        class="my-3 dark:text-light-50 text-dark-900 font-normal"
        v-html="$t(leftLabel)"
      />
    </slot>
    <div class="flex flex-row flex-nowrap items-center">
      <slot name="right-label">
        <span
          v-if="!!actionText"
          class="mt-2.5 mb-2.5 mr-1 dark:text-primary-blue-100 text-primary-blue-300 text-xs flex flex-row cursor-pointer font-normal"
          v-html="$t(actionText)"
        />
      </slot>
      <slot name="right-icon">
        <component
          :is="iconName"
          v-if="!!iconName"
          class="h-4 text-xs dark:text-primary-blue-100 text-primary-blue-300 font-light"
        />
      </slot>
    </div>

    <div
      v-if="disabled"
      class="absolute top-0 left-0 bg-dark-200/50 dark:bg-dark-800/50 cursor-not-allowed w-full h-full z-5 rounded-lg"
    />
  </div>
</template>
